/* tslint:disable */
/* eslint-disable */
/**
 * Kalkulacka API
 * Kalkulacka web api
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: lolita.havrychko@synetech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCategory200ResponseValueSubcategoriesValue
 */
export interface GetCategory200ResponseValueSubcategoriesValue {
    /**
     * 
     * @type {string}
     * @memberof GetCategory200ResponseValueSubcategoriesValue
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategory200ResponseValueSubcategoriesValue
     */
    nameUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCategory200ResponseValueSubcategoriesValue
     */
    order?: number;
}

/**
 * Check if a given object implements the GetCategory200ResponseValueSubcategoriesValue interface.
 */
export function instanceOfGetCategory200ResponseValueSubcategoriesValue(value: object): boolean {
    return true;
}

export function GetCategory200ResponseValueSubcategoriesValueFromJSON(json: any): GetCategory200ResponseValueSubcategoriesValue {
    return GetCategory200ResponseValueSubcategoriesValueFromJSONTyped(json, false);
}

export function GetCategory200ResponseValueSubcategoriesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCategory200ResponseValueSubcategoriesValue {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'nameUrl': json['name-url'] == null ? undefined : json['name-url'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function GetCategory200ResponseValueSubcategoriesValueToJSON(value?: GetCategory200ResponseValueSubcategoriesValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'name-url': value['nameUrl'],
        'order': value['order'],
    };
}

